import { render } from "./TaskSettingsFooter.vue?vue&type=template&id=40ec346d"
import script from "./TaskSettingsFooter.vue?vue&type=script&lang=js"
export * from "./TaskSettingsFooter.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsFooter.vue?vue&type=style&index=0&id=40ec346d&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__